import { Calendar } from 'lucide-react';
import {
	FrequencyTypeEnum,
	type CertificationPeriodSuggestionViewModel,
	type EvaluationCommandModel,
	type FullOrderViewModel,
	type RoutineFrequencyCommandModel,
	type RoutinePrnFrequencyCommandModel
} from '@generated';
import { Button } from '~/shared/components/buttons/Button';
import { EditFrequenciesFormModal } from './edit/EditFrequenciesFormModal';

function getSuggestedFrequencyPlan(
	fullOrder: FullOrderViewModel,
	performingUserId: string,
	disciplineId: number,
	suggestedFrequencyPlan?: CertificationPeriodSuggestionViewModel
): {
	evaluations: EvaluationCommandModel[];
	routineFrequencies: RoutineFrequencyCommandModel[];
	prnFrequencies: RoutinePrnFrequencyCommandModel[];
} {
	return {
		evaluations: [
			...fullOrder.evaluations,
			...(suggestedFrequencyPlan
				? suggestedFrequencyPlan.calculateSuggestedFrequencies
						.filter(x => x.frequencyTypeId === FrequencyTypeEnum.Evaluation)
						.map(x => ({ ...x, physicianRequested: false }))
				: [])
		],
		routineFrequencies: [
			...fullOrder.routine,
			...(suggestedFrequencyPlan
				? suggestedFrequencyPlan.calculateSuggestedFrequencies
						.filter(x => x.frequencyTypeId === FrequencyTypeEnum.Routine)
						.map(f => ({
							...f,
							assignedToId: f.disciplineId === disciplineId ? performingUserId : undefined
						}))
				: [])
		],
		prnFrequencies: suggestedFrequencyPlan ? suggestedFrequencyPlan.calculateSuggestedPrnFrequencies.map(x => ({ ...x, prnReason: '' })) : []
	};
}

export function FrequenciesForVisit({
	fullOrder,
	suggestedFrequencyPlan,
	defaultAssignment
}: {
	fullOrder: FullOrderViewModel;
	suggestedFrequencyPlan?: CertificationPeriodSuggestionViewModel;
	defaultAssignment: { userId: string; disciplineId: number };
}) {
	const displaySuggestedFrequencies =
		suggestedFrequencyPlan && suggestedFrequencyPlan.calculateSuggestedFrequencies.length > 0 && !fullOrder.suggestedFrequenciesApplied;
	const initialFrequencies = displaySuggestedFrequencies
		? getSuggestedFrequencyPlan(fullOrder, defaultAssignment.userId, defaultAssignment.disciplineId, suggestedFrequencyPlan)
		: undefined;

	return (
		<Button
			aria-label="View Frequencies"
			Icon={Calendar}
			className="rounded-lg p-2"
			intent="neutral"
			statusIndicator={displaySuggestedFrequencies ? 'success' : undefined}
			useSuspense
			renderModal={closeModal => (
				<EditFrequenciesFormModal fullOrder={fullOrder} closeModal={closeModal} suggestedFrequencies={initialFrequencies} />
			)}
		/>
	);
}
